$(document).ready(function(e) {
    $('.js-banner-from-desktop').ajaxForm({
        beforeSubmit: function (formData, jqForm, options) {
            jqForm.find('.js-form-input').removeClass('input--error');
            jqForm.find('.js-form-error').text('').hide();
        },
        dataType: 'html',
        success: function (response, status, xhr, jqForm) {
            response = jQuery.parseJSON(response);
            if (response.data.errors) {
                for (var field in response.data.errors) {
                    var errorMessage = response.data.errors[field];
                    var inputWrap = jqForm.find('[name="' + field + '"]').parents('.js-form-item');
                    inputWrap.find('.js-form-input').addClass('input--error');
                    inputWrap.find('.js-form-error').text(errorMessage).show();
                }
            } else {
                jqForm[0].reset();
                showModal('modal-form-map-success');
                var goal = jqForm.data('reach-goal');
                if (!!goal) {
                    reachGoal(goal);
                }
            }
            googleCaptchaBannerDesktop.refresh();
        }
    });

    $('.js-banner-from-mobile').ajaxForm({
        beforeSubmit: function (formData, jqForm, options) {
            jqForm.find('.js-form-input').removeClass('input--error');
            jqForm.find('.js-form-error').text('').hide();
        },
        dataType: 'html',
        success: function (response, status, xhr, jqForm) {
            response = jQuery.parseJSON(response);
            if (response.data.errors) {
                for (var field in response.data.errors) {
                    var errorMessage = response.data.errors[field];
                    var inputWrap = jqForm.find('[name="' + field + '"]').parents('.js-form-item');
                    inputWrap.find('.js-form-input').addClass('input--error');
                    inputWrap.find('.js-form-error').text(errorMessage).show();
                }
            } else {
                jqForm[0].reset();
                showModal('modal-form-map-success');
                reachGoal('form-podv');
            }
            googleCaptchaBannerMobile.refresh();
        }
    });
});